<template>
  <div class="view-orders-empty">
    <app-content-title-back-home title="Мои заказы" />
    <div class="view-orders-empty__wrapper">
      <img src="/static/images/empty.svg" alt="" />
      <h2 class="view-orders-empty__wrapper-title">У вас пока нет заказов</h2>
      <p class="view-orders-empty__wrapper-text">
        Давайте подберем для вас подходящее предложение!
      </p>
      <a href="#" class="btn btn-primary">Выбрать предложение</a>
    </div>
    <app-carousel-stories
      lass="view-orders-empty__stories"
      :items="stories"
    ></app-carousel-stories>
  </div>
</template>

<script>
const { BASE_URL } = process.env;

export default {
  name: 'ViewOrdersIndex',
  components: {
    AppContentTitleBackHome: () =>
      import('@/components/common/AppContentTitleBackHome'),
    AppCarouselStories: () =>
      import('@/components/common/sliders/AppCarouselStories'),
  },
  data: () => ({
    stories: [
      {
        title: 'Лайфхаки в оформлении заказа',
        id: '1',
        link: '/',
        img: `${BASE_URL}static/images/stories/story1.png`,
      },
      {
        title: 'Как пополнить счёт',
        id: '2',
        link: '/',
        img: `${BASE_URL}static/images/stories/story2.png`,
      },
      {
        title: 'Как назначить организацию основной',
        id: '3',
        link: '/',
        img: `${BASE_URL}static/images/stories/story3.png`,
      },
      {
        title: 'Как отследить заказ',
        id: '4',
        link: '/',
        img: `${BASE_URL}static/images/stories/story4.png`,
      },
      {
        title: 'Как проверить контрагента',
        id: '5',
        link: '/',
        img: `${BASE_URL}static/images/stories/story5.png`,
      },
    ],
  }),
};
</script>

<style lang="scss">
.view-orders-empty {
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 50vh;
    padding: 120px 40px;
    margin: 0 0 30px;
    background: #fff;
    box-shadow: 0 4px 10px rgba(221, 222, 222, 0.5);

    &-title {
      margin: 30px 0 10px;
      font-size: rem(18);
      font-weight: 300;
      color: #000;
    }

    &-text {
      font-size: rem(13);
      font-weight: 300;
      color: #8c8c8c;
    }
  }
}
</style>
